/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImportAuthenticationTypeModel { 
    dn?: string | null;
    username?: string | null;
    authMethod?: string | null;
    sendTo?: string | null;
    mobile?: string | null;
    email?: string | null;
    seed?: string | null;
    serialId?: string | null;
    period?: string | null;
    deviceType?: string | null;
    deviceToken?: string | null;
    value?: string | null;
    createdBy?: string | null;
    createdOn?: string;
    modifiedBy?: string | null;
    modifiedOn?: string | null;
}

